import { Component, ElementRef} from '@angular/core';
import { AuthorizationService } from '@app/core/service';

@Component({
  selector: 'app-authorization-service',
  template: '',
  standalone: true
})
export class AuthorizationServiceComponent {
  constructor(
    element: ElementRef,
    service: AuthorizationService) {
    element.nativeElement.service = service;
  }
}
